import { ACTION_TYPES, PAGE_SUBSECTIONS, PAGES } from "utils/gtm/gtmEventsData"

import { CallButton } from "features/clients/components"
import WhatsappCallButton from "features/clients/components/whatsapp-call-button"
import { t } from "i18next"
import { fireEvent } from "utils/gtm/gtmEventHandler"
import getPrivilege from "utils/privileges/privileges"
import theme from "utils/themeVars"
import styles from "./getActionButton.module.less"
import MaqsamCallButton from "../../../clients/components/maqsam-call-button"
import { configs } from "../../../../configs"
import { isModule } from "utils"
import GrandStreamCallButton from "../../../clients/components/grandStreamCallButton"

export default function getActionButtons({
  lead,
  isListing,
  client,
  formRefs,
  onActionClick,
  user,
  from,
  userPrivileges,
  index,
  privileges,
}) {
  const isSharedLeadsPage = isModule("shared-leads")
  return [
    ...(isListing
      ? [
          ...(isSharedLeadsPage && configs?.allowMaqsamCall
            ? [
                {
                  key: "maqsam",
                  Component: () => (
                    <MaqsamCallButton
                      client={lead?.Client}
                      shape="circle"
                      from={{
                        page: PAGES.telesales_listing_page,
                        interacted_from: PAGE_SUBSECTIONS.telesales_leads_listing,
                      }}
                      leadId={lead?.id}
                      disabled={!getPrivilege("can_view_client_contact", privileges)}
                    />
                  ),
                },
              ]
            : []),
          {
            key: "call",
            Component: () => (
              <CallButton
                client={lead?.Client}
                shape="circle"
                leadId={lead?.id}
                from={from}
                disabled={!getPrivilege("can_view_client_contact", privileges)}
              />
            ),
          },
          ...(configs?.allowGrandStreamCall
            ? [
                {
                  key: "grandStream",
                  Component: () => (
                    <GrandStreamCallButton
                      client={lead?.Client}
                      shape="circle"
                      from={{
                        page: PAGES.telesales_listing_page,
                        interacted_from: PAGE_SUBSECTIONS.telesales_leads_listing,
                      }}
                      leadId={lead?.id}
                      disabled={!getPrivilege("can_view_client_contact", privileges)}
                    />
                  ),
                },
              ]
            : []),
          {
            key: "whatsapp",
            Component: () => (
              <WhatsappCallButton
                client={lead?.Client}
                leadId={lead?.id}
                from={from}
                disabled={!getPrivilege("can_view_client_contact", privileges)}
              />
            ),
          },
        ]
      : []),
    {
      key: "add_task",
      icon: "MdAddTask",
      color: theme["primary-color"],
      content: t("Add Action"),
      title: t("Select Action Type"),
      iconTextWrapperClass: styles.actionDropdDown,
      options: [
        {
          key: "2",
          label: t("Add Task"),
          icon: "MdAddTask",
          color: theme["primary-green-1"],
          size: "16px",
          onClick: () => {
            fireEvent({
              ...ACTION_TYPES.lead_actions_click_on_add_task,
              client_id: client?.id || lead?.Client?.id,
              lead_id: lead?.id,
              ...from,
            })
            onActionClick(formRefs.addTaskRef, lead, index, "addTask")
          },
          disabled: !getPrivilege("can_add_task_on_lead", privileges),
        },
        ...(isSharedLeadsPage
          ? [
              {
                key: "2",
                label: t("Add Review"),
                color: theme["primary-green-1"],
                size: "16px",
                icon: "MdOutlineRateReview",

                onClick: () => {
                  fireEvent({
                    ...ACTION_TYPES.lead_review_button_lead,
                    client_id: client?.id || lead?.Client?.id,
                    lead_id: lead.id,
                    ...from,
                  })
                  onActionClick(formRefs.addReviewLeadFormRef, lead, index)
                },
                disabled: !(getPrivilege("can_add_lead_review", privileges) && lead.User?.id !== user?.id),
              },
            ]
          : []),
        {
          key: "fillProfile",
          icon: "TbEdit",
          size: "16px",
          color: theme["primary-green-1"],
          label: t("Fill Profile"),
          onClick: () => {
            onActionClick(formRefs.clientProfileRef, lead)
          },
          disabled: !getPrivilege("can_edit_client", privileges),
        },

        {
          key: "3",
          label: t("Generate Proposal"),
          icon: "FaMagic",
          color: theme["primary-green-1"],
          size: "16px",
          onClick: () => {
            onActionClick(formRefs.proposalGenerationRef, lead)
          },
          disabled: !getPrivilege("can_generate_proposal", userPrivileges) || lead?.interestedIn === "mortgage",
        },
        {
          key: "aiSalesPitch",
          label: t("Generate Sales Pitch"),
          icon: "SvgIconAi",
          iconProps: {
            id: lead?.id,
          },
          color: theme["primary-green-1"],
          size: "16px",
          onClick: () => {
            formRefs.aiSaleGenRef?.current?.setModal({ clientId: lead?.clientId, leadId: lead?.id })
          },
          disabled: !getPrivilege("can_generate_sales_pitch", userPrivileges),
        },

        {
          key: "add_sales",
          icon: "BsCreditCard",
          color: theme["primary-green-1"],
          label: t("Add Sale"),
          size: "16px",

          ...(configs?.myzameen
            ? {
                children: [
                  {
                    key: "units",
                    label: t("On Unit"),
                    onClick: () => {
                      fireEvent({
                        ...ACTION_TYPES.lead_actions_click_on_add_sale,
                        ...from,
                        client_id: client?.id || lead?.Client?.id,
                        lead_id: lead.id,
                      })
                      onActionClick(formRefs.addSaleFormRef, lead)
                    },
                  },
                  {
                    key: "blocks",
                    label: t("On Block"),
                    onClick: () => {
                      onActionClick(formRefs.fractionalSalesRef, lead, index, "fractionalSales")
                    },
                  },
                ],
              }
            : {
                onClick: () => {
                  fireEvent({
                    ...ACTION_TYPES.lead_actions_click_on_add_sale,
                    ...from,
                    client_id: client?.id || lead?.Client?.id,
                    lead_id: lead.id,
                  })
                  onActionClick(formRefs.addSaleFormRef, lead)
                },
              }),
          disabled: !getPrivilege("can_add_sale_on_lead", privileges) || lead?.interestedIn === "mortgage",
        },
        {
          key: "mortage_assessment",
          icon: "BsCreditCard",
          color: theme["primary-green-1"],
          label: t("Bank Loan Assessment"),
          size: "16px",
          onClick: () => {
            onActionClick(formRefs.mortgageAssessmentRef, lead)
          },
          disabled: !getPrivilege("can_access_mortgage_calculator", userPrivileges),
        },
        {
          key: "apply_discount",
          icon: "SvgIcApplyDiscount",
          color: theme["primary-green-1"],
          label: t("Apply Discounts"),
          size: "16px",
          disabled: !(
            !lead?.verifiedClosedWon &&
            lead?.discountEligibility &&
            getPrivilege("can_apply_discount", privileges) &&
            !lead?.InternalInquiryStatus?.closeStatus
          ),
          onClick: () => {
            fireEvent({
              ...ACTION_TYPES.lead_apply_discount_button,
              ...from,
              client_id: client?.id || lead?.Client?.id,
              lead_id: lead.id,
            })
            onActionClick(formRefs.addApplyForDiscountFormRef, lead)
          },
        },
        {
          key: "addToPipeline",
          icon: "BsPersonX",
          color: theme["primary-green-1"],
          label: t("Add to Pipeline"),
          size: "16px",
          onClick: () => {
            const pipelineRef =
              lead?.interestedIn === "investment" ? formRefs.addInvestmentWealthPipelineRef : formRefs.addToSalesPipeline
            onActionClick(pipelineRef, lead)
          },
          disabled: !getPrivilege("can_add_to_pipeline", userPrivileges) || lead?.interestedIn === "mortgage",
        },
        ...(lead?.isInAuditConcern
          ? [
              {
                key: "watchlistAction",
                icon: "BsPersonX",
                color: theme["primary-green-1"],
                label: t("Remove Audit Concern"),
                size: "16px",
                disabled: !getPrivilege("can_remove_audit_concern", userPrivileges),
                onClick: () => {
                  onActionClick(formRefs.watchListRef, lead)
                },
              },
            ]
          : []),
        {
          key: "closeLost",
          icon: "BsPersonX",
          color: theme["primary-green-1"],
          label: t("Mark Lead as Closed(LOST)"),
          size: "16px",
          disabled: !getPrivilege("can_mark_lead_a_closed_lost", privileges),
          onClick: () => {
            onActionClick(formRefs.closeLostRef, lead)
          },
        },
      ],
    },
    {
      key: "logs",
      icon: "IoDocumentTextOutline",
      color: theme["primary-color"],
      content: t("Logs"),
      title: t("View & Add"),
      iconTextWrapperClass: styles.actionDropdDown,
      options: [
        {
          key: "tasks",
          icon: "IconTaskList",
          color: theme["primary-green-1"],
          size: "16px",
          label: t("Task Logs"),
          onClick: () => {
            fireEvent({
              ...ACTION_TYPES.lead_task_overview_button,
              client_id: client?.id || lead?.Client?.id,
              lead_id: lead?.id,
              ...from,
            })
            onActionClick(formRefs.taskLogRef, lead, index, "tasks")
          },
          disabled: !getPrivilege("can_see_task_logs", userPrivileges),
        },
        {
          key: "calls",
          icon: "IconCallLogs",
          color: theme["primary-green-1"],
          size: "16px",
          label: t("Call Logs"),
          onClick: () => {
            isSharedLeadsPage
              ? onActionClick(formRefs.callDrawerRef, lead, index, "callLogs")
              : formRefs.callDrawerRef?.current?.showDrawer(lead?.Client)
            fireEvent({
              ...ACTION_TYPES.listing_call_logs,
              client_id: lead?.Client?.id,
            })
          },
          disabled: !getPrivilege("can_view_call_logs", privileges),
        },
        {
          key: "whatsappChats",
          icon: "RiWhatsappFill",
          color: theme["primary-green-1"],
          size: "16px",
          label: t("View Chats"),
          onClick: () => {
            onActionClick(formRefs.whatsappChatDrawerRef, lead, index, "whatsappChats")
          },
          disabled: !getPrivilege("can_view_whatsapp_chat_logs", privileges),
        },
        ...(isSharedLeadsPage
          ? [
              {
                key: "leadReviews",
                icon: "MdOutlineRateReview",
                color: theme["primary-green-1"],
                size: "16px",
                label: t("Add Reviews"),
                onClick: () => {
                  onActionClick(formRefs.addReviewLeadFormRef, lead, index, "leadReview")
                },
                disabled: lead?.User?.id === user?.id,
              },
            ]
          : [
              {
                key: "2",
                label: t("Add Review"),
                color: theme["primary-green-1"],
                size: "16px",
                icon: "MdOutlineRateReview",

                onClick: () => {
                  fireEvent({
                    ...ACTION_TYPES.lead_review_button_lead,
                    client_id: client?.id || lead?.Client?.id,
                    lead_id: lead.id,
                    ...from,
                  })
                  onActionClick(formRefs.addReviewLeadFormRef, lead, index, "leadReview")
                },
                disabled: !(
                  (getPrivilege("can_add_lead_review", userPrivileges) ||
                    getPrivilege("can_add_audit_review", userPrivileges)) &&
                  lead.User?.id !== user?.id
                ),
              },
            ]),
        {
          key: "3",
          icon: "SvgMenuClients",
          color: theme["primary-green-1"],
          label: t("Observation Meeting"),
          size: "16px",
          onClick: () => {
            fireEvent({
              ...ACTION_TYPES.lead_review_button_meeting,
              client_id: client?.id || lead?.Client?.id,
              lead_id: lead.id,
              ...from,
            })
            onActionClick(formRefs.addReviewLeadFormRef, lead, index, "observationMeeting")
          },
          disabled: !(getPrivilege("can_add_lead_review", privileges) && lead.User?.id !== user.id),
        },
      ],
    },

    ...(!isSharedLeadsPage
      ? [
          {
            icon: "IoMdShareAlt",
            color: theme["error-color"],
            content: t("Share Lead"),
            title: t("Select Share Type"),
            iconTextWrapperClass: styles.actionDropdDown,
            disabled:
              !getPrivilege("can_share_lead_with_sales", privileges) &&
              !getPrivilege("can_share_lead_with_support", privileges),
            options: [
              {
                key: "2",
                label: t("Sale"),
                icon: "IoPricetagOutline",
                color: theme["primary-green-1"],
                size: "16px",
                onClick: () => {
                  fireEvent({
                    ...ACTION_TYPES.lead_sharing_button_with_sale,
                    ...from,
                    client_id: client?.id || lead?.Client?.id,
                    lead_id: lead?.id,
                  })
                  onActionClick(formRefs.shareLeadSaleFormRef, lead)
                },
                disabled: !getPrivilege("can_share_lead_with_sales", privileges),
              },
              {
                key: "3",
                label: t("Support"),
                icon: "BiSupport",
                color: theme["primary-green-1"],
                size: "16px",
                onClick: () => {
                  fireEvent({
                    ...ACTION_TYPES.lead_sharing_button_with_support,
                    ...from,
                    client_id: client?.id || lead?.Client?.id,
                    lead_id: lead?.id,
                  })
                  onActionClick(formRefs.shareLeadSupportFormRef, lead)
                },
                disabled: !getPrivilege("can_share_lead_with_support", privileges),
              },
            ],
          },
        ]
      : []),
  ]
}
